import { render, staticRenderFns } from "./PaoNode.vue?vue&type=template&id=08f27948&scoped=true"
import script from "./PaoNode.vue?vue&type=script&lang=js"
export * from "./PaoNode.vue?vue&type=script&lang=js"
import style0 from "./PaoNode.vue?vue&type=style&index=0&id=08f27948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f27948",
  null
  
)

export default component.exports